import request from '@/utils/request'; // 字典查询

export function getBaseDateInfo(query) {
  return request({
    url: '/commondictionary/dictionary/queryByCodeType',
    method: 'post',
    data: query
  });
} // 字典批量查询集合

export function getBaseDateList(query) {
  return request({
    url: '/commondictionary/dictionary/codeTypeList',
    method: 'post',
    data: query
  });
} // 获取省市区

export function getProvinceCityArea(query) {
  return request({
    url: '/commondictionary/dictionary/getProvinceCityArea',
    method: 'post',
    data: query
  });
} // 获取保险公司集合

export function getCompanyList() {
  return request({
    url: '/ecargoaccount/user/findInsuranceCompany',
    method: 'get'
  });
} // 获取中介经办人集合

export function getAgentMan(query) {
  return request({
    url: '/ecargopolicy/BcIntermediary/findAllBcAgentMan',
    method: 'get',
    params: query
  });
} // 获取上级机构

export function getUpperCompany(query) {
  return request({
    url: '/ecargopolicy/company/getUpperCompany',
    method: 'get',
    params: query
  });
} // 获取归属机构集合

export function getAgencyLisy() {
  return request({
    url: '/ecargopolicy/company/findAll',
    method: 'get'
  });
} // 获取人员集合

export function getSalesMan() {
  return request({
    url: '/ecargopolicy/BcSales/findAll',
    method: 'get'
  });
} // 获取共保人集合

export function getCoInsurer(query) {
  return request({
    url: '/commondictionary/dictionary/queryByCodeType',
    method: 'post',
    data: query
  });
} // 获取中介结构

export function getintermediary() {
  return request({
    url: '/ecargopolicy/BcIntermediary/findAll',
    method: 'get'
  });
} // 获取基础数据下拉框

export function getQueryByCodeType(query) {
  return request({
    url: '/ecargopolicy/BcInsuranceCode/queryByCodeType',
    method: 'post',
    data: query
  });
} // 获取基础数据

export function getBaseCodeByCodeType(query) {
  return request({
    url: '/ecargopolicy/BcInsuranceCode/getBaseCodeByCodeType',
    method: 'get',
    params: query
  });
} // 产品查询

export function getProductList(query) {
  return request({
    url: '/ecargopolicy/risk/queryAll',
    method: 'get',
    params: query
  });
} // 临港平台 产品查询

export function getProductNameList(query) {
  return request({
    url: '/ecargopolicy/rinko/productNameQuery',
    method: 'get',
    params: query
  });
} // 条款查询

export function getClauseList(query) {
  return request({
    url: '/ecargopolicy/clause/queryAll',
    method: 'get',
    params: query
  });
} // 责任查询

export function getKindInfoList(query) {
  return request({
    // url: '/ecargopolicy/clause/queryKind',
    url: '/ecargopolicy/clause/queryKindByClauseType',
    method: 'get',
    params: query
  });
} // 查询自定义标的类型

export function getDefinedList(query) {
  return request({
    url: '/ecargopolicy/item/queryAll',
    method: 'post',
    data: query
  });
} // 特约集合risk/queryAll

export function getEngageList(query) {
  return request({
    url: '/ecargopolicy/engage/queryAll',
    method: 'get',
    params: query
  });
} // 免赔集合

export function getLimitList(query) {
  return request({
    url: '/ecargopolicy/limit/queryAll',
    method: 'get',
    params: query
  });
} // 根据洲国家查询子集

export function continentList(query) {
  return request({
    url: '/commondictionary/dictionary/continent',
    method: 'post',
    data: query
  });
} // 分支机构查询

export function getChilComList(query) {
  return request({
    url: '/ecargopolicy/company/queryAll',
    method: 'get',
    params: query
  });
} // 洲-国家-城市初始化

export function getAllContinent(query) {
  return request({
    url: '/commondictionary/dictionary/allContinent',
    method: 'get',
    params: query
  });
} // 根据类型查询条款信息

export function getClauseListByType(query) {
  return request({
    url: '/ecargopolicy/clause/queryClauseByType',
    method: 'post',
    data: query
  });
} // 标的数据处理

export function getItemList(query) {
  return request({
    url: '/commondictionary/dictionary/queryAllByCodeType',
    method: 'get',
    params: query
  });
} // 运维页面redis缓存删除

export function getCleanCacheRedis(query) {
  return request({
    url: '/commondictionary/cleanCache/cleanCacheRedis?key=' + query,
    method: 'get'
  });
} // 查询当前洲-国家-城市数据

export function queryAllContinent(query) {
  return request({
    url: '/commondictionary/dictionary/queryCountry',
    method: 'post',
    data: query
  });
}
export function getAllsCCPC() {
  return request({
    url: '/commondictionary/dictionary/allCCPC',
    method: 'get'
  });
} // 港口城市配置分页查询

export function StateProvincePageInfo(data) {
  return request({
    url: '/commondictionary/dictionary/StateProvincePageInfo',
    method: 'post',
    data: data
  });
} //  港口城市配置保存

export function stateProvinceSave(data) {
  return request({
    url: '/commondictionary/dictionary/stateProvinceSave',
    method: 'post',
    data: data
  });
} //  查询

export function queryCityNameByCode(data) {
  return request({
    url: '/commondictionary/dictionary/queryCityNameByCode',
    method: 'post',
    data: data
  });
} //  删除城市

export function deleteStateProvince(data) {
  return request({
    url: '/commondictionary/dictionary/deleteStateProvince',
    method: 'get',
    params: data
  });
} // 根据保险公司code查询理赔代理点对应的四级联动地址数据

export function queryliPeiData(query) {
  return request({
    url: '/ecargopolicy/agentClaim/QueryAll',
    method: 'post',
    data: query
  });
} // 根据归属机构获取中介结构

export function getintermediaryByComCode(query) {
  return request({
    url: '/ecargopolicy/BcIntermediary/findIntermediaryByComCode',
    method: 'get',
    params: query
  });
} // 根据归属机构获取中介结构

export function getfindSalesByComCode(query) {
  return request({
    url: '/ecargopolicy/BcSales/findSalesByComCode',
    method: 'get',
    params: query
  });
} // 报关单投保 置灰的接口
// export function getDisabledData(query) {
//   return request({
//     url: '/ecargopolicy/proposalQuery/policyLogQuery',
//     method: 'post',
//     data: query
//   })
// }